import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import MuiLoader from "../../components/MuiLoader";
import MuiHeader from "../../components/MuiHeader";
import {
  InputLabel,
  FormControl,
  Select,
  MenuItem,
  CircularProgress,
  Button,
  TextField,
} from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import Swal from "sweetalert2";
import moment from "moment";
import { getAppSessionsThunk, logoutUserThunk } from "./AppSession.thunk";
import api from "../../api/api";
import SearchIcon from "@mui/icons-material/Search";
import {
  setEncryptedItem,
  getDecryptedItem,
  removeItem,
} from "../../utils/storageUtils";

//^-------Usertypes used --------
const appList = [
  { value: "tz", text: "Thinkzone", id: 1 },
  { value: "mis", text: "MIS", id: 2 },
  { value: "report", text: "MIS Report", id: 3 },
  { value: "support", text: "Support App", id: 4 },
  { value: "chatbot", text: "Chatbot", id: 5 },
];

const tzappUserList = [
  { value: "fellow", text: "Educator", id: 1 },
  { value: "school", text: "School", id: 2 },
  { value: "anganwadi", text: "Anganwadi", id: 3 },
];

const supportAppUserList = [
  { value: "manager", text: "Manager", id: 1 },
  { value: "supervisor", text: "Supervisor", id: 2 },
  { value: "crc", text: "CRC", id: 3 },
];
const misReportUserList = [
  { value: "prakashak", text: "Prakashak", id: 1 },
  { value: "admin", text: "Admin", id: 2 },
  { value: "mis", text: "MIS", id: 3 },
];
const misUserList = [
  { value: "superadmin", text: "Super Admin", id: 1 },
  { value: "admin", text: "Admin", id: 2 },
  { value: "mis", text: "MIS", id: 3 },
];
const chatbotUserList = [
  { value: "superadmin", text: "Super Admin", id: 1 },
  { value: "admin", text: "Admin", id: 2 },
  { value: "user", text: "User", id: 3 },
];

const AppSession = () => {
  //~-------------------------------------------------------------------------
  const [appType, setAppType] = useState("");
  const [usertype, setUsertype] = useState("");
  const [searchname, setSearchname] = useState("");
  const [filteredUser, setFilteredUser] = useState([]);
  const userName = getDecryptedItem("username");
  const dispatch = useDispatch();
  const appSessionData = useSelector(
    (state) => state.AppSessionSlice.appSessionData
  );
  const logoutData = useSelector((state) => state.AppSessionSlice.logoutData);
  const loading = useSelector((state) => state.AppSessionSlice.loading);

  const updatedAppSessionData =
    appSessionData?.length > 0 &&
    appSessionData?.filter((item) => item?.username !== userName);
  console.log("updatedAppSessionData", updatedAppSessionData);

  const changeApplicationType = (e) => {
    setAppType(e.target.value);
    setUsertype("");
    setSearchname("");
    setFilteredUser([]);

    if (e.target.value === "mis") {
      const params = {
        appType: e.target.value,
      };
      dispatch(getAppSessionsThunk(params));
    } else {
      dispatch(getAppSessionsThunk(""));
    }
  };

  //^---Usertype change---------
  const changeUsertype = (e) => {
    if (!e.target.value) {
      setUsertype("");
      dispatch(getAppSessionsThunk(""));
      setSearchname("");
      setFilteredUser([]);
    } else {
      setUsertype(e.target.value);
      const body = {
        appType: appType,
        usertype: e.target.value,
      };
      dispatch(getAppSessionsThunk(body));
      setSearchname("");
      setFilteredUser([]);
    }
  };

  //^-----Searching an user----------
  const handleNameOnSearch = (event) => {
    if (event.target.value) {
      const searchedValue = event.target.value.toLowerCase();
      setSearchname(searchedValue);
      const searchedUser = updatedAppSessionData?.filter((item) => {
        return (
          item.username.toLowerCase().includes(searchedValue) &&
          item.username !== userName
        );
      });
      console.log("searchedValue--------->", searchedValue);
      console.log("searchedUser----------->", searchedUser);
      setFilteredUser(searchedUser);
    } else {
      setSearchname("");
      setFilteredUser([]);
    }
  };

  //!-----For logging out the user after entering password------
  // const logoutSingleUser = async (item) => {
  //   const { value: inputValue } = await Swal.fire({
  //     title: "Enter the password",
  //     input: "text",
  //     inputPlaceholder: "Enter the password to log out this user",
  //     confirmButtonText: "Log Out",
  //     confirmButtonColor: "#3085d6",
  //     showCancelButton: true,
  //     cancelButtonText: "Cancel",
  //     cancelButtonColor: "#d33",
  //     inputValidator: (value) => {
  //       if (!value) {
  //         return "Please enter the password!";
  //       } else if (value !== "thinkzone@CDA11-753015") {
  //         return "Password is incorrect!";
  //       }
  //     },
  //   });

  //   if (inputValue === "thinkzone@CDA11-753015") {
  //     const body = {
  //       userid: item.userid,
  //       appType: appType,
  //       password: "thinkzone@CDA11-753015",
  //     };

  //     try {
  //       api
  //         .delete(`logoutUser/${body.userid}/${body.appType}/${body.password}`)
  //         .then((res) => {
  //           if (res.status === 200) {
  //             toast.success("Successfully logged out this user !", {
  //               style: {
  //                 backgroundColor: "grey",
  //                 color: "white",
  //                 borderRadius: "30px",
  //               },
  //             });
  //             const data = {
  //               appType: appType,
  //               usertype: usertype,
  //             };
  //             dispatch(getAppSessionsThunk(data));
  //             if (searchname && filteredUser) {
  //               setSearchname("");
  //               setFilteredUser([]);
  //             }
  //           } else {
  //             console.log("status: ", res.status);
  //           }
  //         })
  //         .catch((err) => {
  //           console.error(`The error in getting data: ${err}`);
  //         });
  //     } catch (err) {
  //       console.log("Error:", err);
  //     }
  //   }
  // };
  const logoutSingleUser = async (item) => {
    const { value: inputValue } = await Swal.fire({
      title: "Enter the password",
      input: "text",
      inputPlaceholder: "Enter the password to log out this user",
      confirmButtonText: "Log Out",
      confirmButtonColor: "#3085d6",
      showCancelButton: true,
      cancelButtonText: "Cancel",
      cancelButtonColor: "#d33",
      inputValidator: (value) => {
        if (!value) {
          return "Please enter the password!";
        } else if (value !== "thinkzone@CDA11-753015") {
          return "Password is incorrect!";
        }
      },
    });

    if (inputValue === "thinkzone@CDA11-753015") {
      const body = {
        userid: item.userid,
        appType: appType,
        password: "thinkzone@CDA11-753015",
      };

      try {
        const res = await api.delete(
          `logoutUser/${body.userid}/${body.appType}/${body.password}`
        );

        if (res.status === 200) {
          toast.success("Successfully logged out this user !", {
            style: {
              backgroundColor: "grey",
              color: "white",
              borderRadius: "30px",
            },
          });
          const data = {
            appType: appType,
            usertype: usertype,
          };
          dispatch(getAppSessionsThunk(data));
          if (searchname && filteredUser) {
            setSearchname("");
            setFilteredUser([]);
          }
        } else {
          console.log("status: ", res.status);
        }
      } catch (err) {
        if (err.response) {
          if (err.response.status === 500) {
            toast.error("Internal Server Error. Please try again later.", {
              style: {
                backgroundColor: "red",
                color: "white",
                borderRadius: "30px",
              },
            });
          } else if (err.response.status === 504) {
            toast.error("Gateway Timeout. Please try again later.", {
              style: {
                backgroundColor: "red",
                color: "white",
                borderRadius: "30px",
              },
            });
          } else {
            toast.error(
              `Error: ${err.response.status}. Please try again later.`,
              {
                style: {
                  backgroundColor: "red",
                  color: "white",
                  borderRadius: "30px",
                },
              }
            );
          }
        } else {
          console.error(`The error in getting data: ${err}`);
        }
      }
    }
  };

  //!-----For logging out all users after entering password------
  //?-----Commented out for now, will be used in future if API is made for the same------
  // const logoutAllUsers = async () => {
  //   const { value: inputValue } = await Swal.fire({
  //     title: "Enter the password",
  //     input: "text",
  //     inputPlaceholder: "Enter password to log out all users",
  //     showCancelButton: true,
  //     cancelButtonColor: "#d33",
  //     confirmButtonText: "Log Out",
  //     confirmButtonColor: "#3085d6",
  //     inputValidator: (value) => {
  //       if (!value) {
  //         return "Please enter the password !";
  //       } else if (value !== "thinkzone@CDA11-753015") {
  //         return "Password is incorrect !";
  //       }
  //     },
  //   });
  //   if (inputValue === "thinkzone@CDA11-753015") {
  //     const body = {};
  //     const response = dispatch(logoutUserThunk(body));
  //     console.log("res got after post API call----------->", response);
  //   }
  // };

  //todo------------------Console logs-----------------------------
  // console.log("appType--------------->", appType);
  // console.log("usertype--------->", usertype);
  console.log("appSessionData--------->", appSessionData);
  console.log("searchname-------------->", searchname);
  console.log("filteredUser--------------->", filteredUser);
  // console.log("logoutData------------->", logoutData);
  // console.log("logoutData.msg------------->", logoutData.msg);
  // console.log("loading------>", loading);

  //~------------------------------------------------------------------------------

  return (
    <div style={{ marginBottom: "5px" }}>
      <MuiHeader header="App Session" />
      <FormControl
        sx={{ marginTop: "-0.5%", width: 160, marginLeft: "1%" }}
        size="small"
      >
        <InputLabel id="demo-select-small">Application</InputLabel>
        <Select
          labelId="demo-select-small"
          id="demo-select-small"
          // value={list}
          label="Application"
          onChange={changeApplicationType}
        >
          <MenuItem value={null}>None</MenuItem>
          {appList.map((item) => (
            <MenuItem key={item.id} value={item.value}>
              {item.text}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {appType && appType !== "mis" ? (
        <FormControl
          sx={{ marginTop: "-0.5%", width: 160, marginLeft: "1%" }}
          size="small"
        >
          <InputLabel id="demo-select-small">Usertype</InputLabel>
          <Select
            labelId="demo-select-small"
            id="demo-select-small"
            value={usertype}
            label="Usertype"
            onChange={changeUsertype}
          >
            <MenuItem value={null}>None</MenuItem>
            {appType === "tz"
              ? tzappUserList.map((item) => (
                  <MenuItem key={item.id} value={item.value}>
                    {item.text}
                  </MenuItem>
                ))
              : appType === "mis"
              ? misUserList.map((item) => (
                  <MenuItem key={item.id} value={item.value}>
                    {item.text}
                  </MenuItem>
                ))
              : appType === "report"
              ? misReportUserList.map((item) => (
                  <MenuItem key={item.id} value={item.value}>
                    {item.text}
                  </MenuItem>
                ))
              : appType === "support"
              ? supportAppUserList.map((item) => (
                  <MenuItem key={item.id} value={item.value}>
                    {item.text}
                  </MenuItem>
                ))
              : appType === "chatbot"
              ? chatbotUserList.map((item) => (
                  <MenuItem key={item.id} value={item.value}>
                    {item.text}
                  </MenuItem>
                ))
              : null}
          </Select>
        </FormControl>
      ) : null}

      {loading === true ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "20px",
          }}
        >
          <CircularProgress />
        </div>
      ) : !loading &&
        appType &&
        updatedAppSessionData &&
        updatedAppSessionData?.length > 0 ? (
        <>
          <TextField
            id="outlined-multiline-static"
            label={
              <span style={{ display: "flex" }}>
                <SearchIcon style={{ marginRight: "5px" }} />
                Search User
              </span>
            }
            variant="outlined"
            sx={{
              width: 340,
              marginTop: 10,
              marginLeft: "-11%",
            }}
            size="small"
            value={searchname}
            onChange={handleNameOnSearch}
          />

          {updatedAppSessionData &&
          !searchname &&
          filteredUser.length === 0 &&
          updatedAppSessionData?.length > 0 ? (
            <h3 style={{ marginLeft: "13px" }}>
              {updatedAppSessionData?.length} record(s) found
            </h3>
          ) : updatedAppSessionData &&
            searchname &&
            filteredUser.length > 0 &&
            updatedAppSessionData?.length > 0 ? (
            <h3 style={{ marginLeft: "13px" }}>
              {filteredUser?.length} record(s) found
            </h3>
          ) : (
            <h3 style={{ marginLeft: "13px" }}>0 record found</h3>
          )}

          {updatedAppSessionData &&
          filteredUser?.length === 0 &&
          !searchname &&
          updatedAppSessionData?.length > 0 ? (
            <div
              style={{
                height: "600px",
                overflowY: "auto",
                marginTop: "60px",
              }}
            >
              <table
                border={8}
                style={{
                  minWidth: "800px",
                  width: "95%",
                  display: "table",
                }}
              >
                <thead
                  style={{
                    backgroundColor: "#f2f2f2",
                    position: "sticky",
                    top: 0,
                    zIndex: 1000,
                  }}
                >
                  <tr style={{}}>
                    <th style={{ padding: "10px" }}>Sl no.</th>
                    <th style={{ padding: "10px" }}>Username</th>
                    {appType !== "mis" && (
                      <th style={{ padding: "10px" }}>Manager name</th>
                    )}
                    {appType !== "mis" && (
                      <th style={{ padding: "10px" }}>Passcode</th>
                    )}
                    <th style={{ padding: "10px" }}>App Version</th>
                    <th style={{ padding: "10px" }}>Login Allowed</th>
                    <th style={{ padding: "10px" }}>Last Used</th>

                    <th style={{ padding: "10px" }}>userType</th>

                    <th style={{ padding: "10px" }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {updatedAppSessionData.map((item, index) => (
                    <>
                      {item.username !== userName && (
                        <tr key={index}>
                          <td style={{ padding: "10px" }}>{index + 1}</td>
                          <td style={{ padding: "10px" }}>{item?.username}</td>
                          {appType !== "mis" && (
                            <td style={{ padding: "10px" }}>
                              {item?.managername}
                            </td>
                          )}
                          {appType !== "mis" && (
                            <td style={{ padding: "10px" }}>
                              {item?.passcode}
                            </td>
                          )}
                          <td style={{ padding: "10px" }}>
                            {item?.appVersion}
                          </td>
                          <td style={{ padding: "10px" }}>
                            {item.login === true ? "True" : "False"}
                          </td>
                          <td style={{ padding: "10px" }}>
                            {moment(item.lastUsed).format(
                              `DD-MM-YYYY HH:mm:ss`
                            )}
                          </td>
                          <td style={{ padding: "10px" }}>{item?.usertype}</td>
                          <td style={{ padding: "10px" }}>
                            <Button
                              variant="contained"
                              disabled={item.logout === true ? true : false}
                              onClick={() => logoutSingleUser(item)}
                            >
                              Log out
                            </Button>
                          </td>
                        </tr>
                      )}
                    </>
                  ))}
                </tbody>
              </table>
            </div>
          ) : searchname &&
            filteredUser &&
            updatedAppSessionData.length > 0 &&
            filteredUser.length > 0 ? (
            <div
              style={{
                height: "600px",
                overflowY: "auto",
                marginTop: "60px",
              }}
            >
              <table
                border={8}
                style={{
                  minWidth: "800px",
                  width: "95%",
                  display: "table",
                }}
              >
                <thead
                  style={{
                    backgroundColor: "#f2f2f2",
                    position: "sticky",
                    top: 0,
                    zIndex: 1000,
                  }}
                >
                  <tr style={{}}>
                    <th style={{ padding: "10px" }}>Sl no.</th>
                    <th style={{ padding: "10px" }}>Username</th>
                    {appType !== "mis" && (
                      <th style={{ padding: "10px" }}>Manager name</th>
                    )}
                    {appType !== "mis" && (
                      <th style={{ padding: "10px" }}>Passcode</th>
                    )}
                    <th style={{ padding: "10px" }}>App Version</th>
                    <th style={{ padding: "10px" }}>Login Allowed</th>
                    <th style={{ padding: "10px" }}>Last Used</th>
                    <th style={{ padding: "10px" }}>userType</th>
                    <th style={{ padding: "10px" }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredUser.map((item, index) => (
                    <tr>
                      <td style={{ padding: "10px" }}>{index + 1}</td>
                      <td style={{ padding: "10px" }}>{item?.username}</td>
                      {appType !== "mis" && (
                        <td style={{ padding: "10px" }}>{item?.managername}</td>
                      )}
                      {appType !== "mis" && (
                        <td style={{ padding: "10px" }}>{item?.passcode}</td>
                      )}
                      <td style={{ padding: "10px" }}>{item?.appVersion}</td>
                      <td style={{ padding: "10px" }}>
                        {item.login === true ? "True" : "False"}
                      </td>
                      <td style={{ padding: "10px" }}>
                        {moment(item.lastUsed).format("DD-MM-YYYY")}
                      </td>
                      <td style={{ padding: "10px" }}>{item?.usertype}</td>
                      <td style={{ padding: "10px" }}>
                        <Button
                          variant="contained"
                          disabled={item?.logout === true ? true : false}
                          onClick={() => logoutSingleUser(item)}
                        >
                          Log out
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <h1 style={{ display: "flex", justifyContent: "center" }}>
              No record found
            </h1>
          )}
        </>
      ) : usertype === "fellow" &&
        loading === false &&
        !updatedAppSessionData ? (
        <div
          style={{ display: "flex", justifyContent: "center", margin: "6%" }}
        >
          <h1>No data available</h1>
        </div>
      ) : appType &&
        usertype &&
        usertype !== "fellow" &&
        loading === false &&
        !updatedAppSessionData ? (
        <div
          style={{ display: "flex", justifyContent: "center", margin: "6%" }}
        >
          <h1>This Module is under development</h1>
        </div>
      ) : null}
      <ToastContainer />
    </div>
  );
};

export default AppSession;
